// src/api/performanceApi.js
//
// Performance Snapshot + Study Streak API calls, matching pyqApi.js's
// convention (askosAuthHeader() passed explicitly per call).
import api from './api';
import { askosAuthHeader } from '../askos/askosApi';

export const getPerformanceSnapshot = (slug, range = 'week') =>
  api.get(`/tenant/${slug}/askos/performance/snapshot`, { headers: askosAuthHeader(), params: { range } }).then(r => r.data);

export const getStreak = (slug) =>
  api.get(`/tenant/${slug}/askos/streak`, { headers: askosAuthHeader() }).then(r => r.data);
